import { PromotionModuleLayout } from "entities/modules/types";
import {
  PageModuleDataWithPageId,
  PageModuleStatus,
} from "entities/pages/types";
import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import ModuleTileHeader from "shared/components/ModuleTileHeader";
import { ContentWrapper } from "../../styled";
import FeaturedCarouselColoredPromotions from "./components/FeaturedCarousel/components/ColoredPromotions";
import FeaturedCarouselSkeleton from "./components/FeaturedCarousel/components/Skeleton";
import GridCarouselColoredPromotions from "./components/GridCarousel/components/ColoredPromotions";
import GridCarouselSkeleton from "./components/GridCarousel/components/Skeleton";
import HorizontalCarouselColoredPromotions from "./components/HorizontalCarousel/components/ColoredPromotions";
import HorizontalCarouselSkeleton from "./components/HorizontalCarousel/components/Skeleton";

interface PromotionsProps {
  isLoading: boolean;
  data: PageModuleDataWithPageId;
  onEditComponent: (data: PageModuleDataWithPageId) => void;
  onDeleteComponent: (data: PageModuleDataWithPageId) => void;
  onUpdateStatus: (params: {
    moduleId: string;
    status: PageModuleStatus;
  }) => void;
}

const Promotions: FC<PromotionsProps> = ({
  isLoading,
  data,
  onEditComponent,
  onDeleteComponent,
  onUpdateStatus,
}) => {
  const getSkeletonComponent = () => {
    switch (data.layout) {
      case PromotionModuleLayout.FeaturedCarousel:
        return <FeaturedCarouselSkeleton />;
      case PromotionModuleLayout.HorizontalScroll:
        return <HorizontalCarouselSkeleton />;
      case PromotionModuleLayout.GridView:
        return <GridCarouselSkeleton />;
      default:
        return <FeaturedCarouselSkeleton />;
    }
  };

  const getComponent = () => {
    switch (data.layout) {
      case PromotionModuleLayout.FeaturedCarousel:
        return <FeaturedCarouselColoredPromotions />;
      case PromotionModuleLayout.HorizontalScroll:
        return <HorizontalCarouselColoredPromotions />;
      case PromotionModuleLayout.GridView:
        return <GridCarouselColoredPromotions />;
      default:
        return <FeaturedCarouselColoredPromotions />;
    }
  };
  return (
    <ContentWrapper>
      {isLoading && (
        <SpaceBetweenCenter>{getSkeletonComponent()}</SpaceBetweenCenter>
      )}
      {!isLoading && (
        <>
          <ModuleTileHeader
            module={data}
            onEditComponent={onEditComponent}
            onDeleteComponent={onDeleteComponent}
            onUpdateStatus={onUpdateStatus}
          />
          {getComponent()}
        </>
      )}
    </ContentWrapper>
  );
};

export default Promotions;
